import * as React from "react";
import SelectComponent from "../ui/select/SelectComponent";

export interface Tax {
	value: number
}

export default class SelectTaxRate extends SelectComponent<Tax> {
	matchFilter(element: Tax, filter: string): boolean {
		return element.value.toString().toLowerCase().indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: Tax): string {
		return element.value.toString();
	}

	elementToString(element: Tax) {
		return `${element.value}%`;
	}
}
